import React, { useContext, useEffect, useState } from "react"
import api from "../../../utils/api"
import { SpaceProfileContext } from "../context"
import SpaceLayout from "../SpaceLayout"
import ProgressDots from "../../ProgressDots"
import { SummaryList } from "../HeroSection"
import SearchResultsForm from "../../SearchResultsForm"
import { format } from "date-fns"
import qs from "query-string"
import { graphql, useStaticQuery } from "gatsby"
import useQueryParams from "../../../utils/useQueryParams"

const Matches = () => {
  const { cms } = useStaticQuery(query)

  const pageData = cms.pageData
  const {
    commonData: {
      location,
      displayPrice,
      filteredOptions,
      filteredOptionsByFloor,
      teamSize,
      moveInDate,
      spaceSummary,
    },
    actions: { setValue },
  } = useContext(SpaceProfileContext)

  const [space_type, setSpaceType] = useQueryParams("space_type", "")

  const [progress, setProgress] = useState(false)

  useEffect(() => {
    if (!teamSize || !location || !location.id) return

    setValue({
      displayPrice: Number(teamSize) < 12,
    })

    let params = {
      team_size: teamSize,
      space_type: spaceSummary.space_type || "Private Offices",
    }
    if (moveInDate && typeof moveInDate === "object") {
      params.move_in_date = format(moveInDate, "yyyy-MM-dd")
    }

    setProgress(true)

    setValue({
      filteredOptionsByFloor: [],
      filteredOptions: [],
    })

    const tsArray = teamSize.split("-")
    const tsMin = tsArray?.[0] || 0
    const tsMax = tsArray?.[1] || tsArray?.[0] || 0

    if (Number(tsMax) > 50) {
      setProgress(false)
      return
    }

    api("search/monthly-spaces", {
      spaceId: location.id,
      params,
      so_id: process.env.GATSBY_SO_ID,
    })
      .then((res) => {
        if (res && res.data && res.data.options) {
          // map the offices and get the least priced ones
          const final = res.data.options
            .filter((o) => o.price > 0)
            .sort(function (a, b) {
              return a.price - b.price
            })
            .slice(0, 2)

          let optionsByFloor = []

          if (final.length === 1) {
            optionsByFloor.push({ ...final[0], items: [final[0]] })
          } else if (final.length === 2) {
            if (final[0].plan_bg === final[1].plan_bg) {
              optionsByFloor.push({ ...final[0], items: [final[0], final[1]] })
            } else {
              optionsByFloor.push(
                { ...final[0], items: [final[0]] },
                { ...final[1], items: [final[1]] }
              )
            }
          }

          setValue({
            filteredOptionsByFloor: optionsByFloor,
            filteredOptions: final,
          })
        }
        setProgress(false)
      })
      .catch((e) => {
        setProgress(false)
        console.log(e)
      })
  }, [teamSize, moveInDate, location, spaceSummary.space_type])

  if (progress) {
    return <ProgressDots active />
  }

  // if (filteredOptions.length === 0) {
  //   return (
  //     <div>
  //       <p>
  //         It seems that we couldn’t find any spaces that match your search
  //         criteria but don’t worry, get in touch with us and a WorkplaceOne
  //         representative will reach out to help you find the right space for
  //         your team.
  //       </p>
  //     </div>
  //   )
  // }

  return (
    <div>
      <SearchResultsForm
        hqSuites={!(Number(teamSize) <= 20)}
        resultsCount={
          filteredOptions && filteredOptions.length > 0
            ? filteredOptions.length
            : 0
        }
        teamSize={teamSize}
        searchParams={qs.parse(window.location.search)}
        activeSpaces={filteredOptions}
        pageData={pageData}
        formTitle={document.title || "Profile Page"}
        emailTitleOverride={
          location && location.space_name
            ? `${location.space_name} - Inquiry`
            : "Location Profile Page - Inquiry"
        }
      />
      {filteredOptions.length > 0 && (
        <>
          <SummaryList displayPrice={displayPrice} space_type={space_type} />
          {filteredOptionsByFloor && filteredOptionsByFloor.length > 0 && (
            <SpaceLayout optionText={true} />
          )}
        </>
      )}
    </div>
  )
}

export default Matches

export const query = graphql`
  query {
    cms {
      pageData: entry(section: "locationsPage") {
        id
        ... on Cms_locationsPage_locationsPage_Entry {
          id
          metaTitle
          metaDescription
          metaImage {
            url(width: 1200, height: 630)
          }
          noResultsFormTitle
          noResultsFormText
          teamSuitesFormTitle
          teamSuitesFormText
          hqSuitesFormTitle
          hqSuitesFormText
          formEmail: locationTitle
        }
      }
    }
  }
`
